/**
 * [BLURY] | 🥭 colour helpers
 * Hex parsing and mixing for the gradient stops.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
import type { Hex } from './types';

type Rgb = [number, number, number];

export function hexToRgb(hex: Hex): Rgb {
  return [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ];
}

/** `rgba()` string for a hex colour at a given alpha. */
export function rgba(hex: Hex, alpha: number): string {
  const [r, g, b] = hexToRgb(hex);
  return `rgba(${r},${g},${b},${alpha})`;
}

/** Linear blend between two hex colours; `t` of 0 returns `a`, 1 returns `b`. */
export function mix(a: Hex, b: Hex, t: number): string {
  const from = hexToRgb(a);
  const to = hexToRgb(b);
  const v = from.map((x, i) => Math.round(x + (to[i] - x) * t));
  return `rgb(${v[0]},${v[1]},${v[2]})`;
}
